import { render, staticRenderFns } from "./FantasyCard.vue?vue&type=template&id=1eb0a8ee&"
import script from "./FantasyCard.vue?vue&type=script&lang=js&"
export * from "./FantasyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports